import React from 'react';

// A render error in one page must not white-screen the whole portal.
//
// WHY THIS EXISTS: the Chatter page rendered a feed value that turned out to be an object
// rather than a string. React treats that as fatal, unmounts everything, and leaves a blank
// white document — no message, no navigation, nothing to report but "it went white". The
// data was fine and the API was fine; one field on one row took out the entire application.
//
// This is specifically for surfaces built on a THIRD PARTY's payload, where a field can
// change shape without any release on this side. It is not a licence to leave errors
// unhandled: it fails loudly and visibly, in place, with the page around it intact.

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // Console only. The message can carry payload values, so it never reaches the screen.
    console.error('Render failed in', this.props.name || 'a page', error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-900/20 dark:text-amber-200">
        <div className="font-medium">This section could not be displayed.</div>
        <p className="mt-1 text-[13px] leading-relaxed">
          Something in the received data was not in the expected shape, so it has been held
          back rather than shown incorrectly. The rest of the portal is unaffected and the
          underlying figures are unchanged.
        </p>
        <button
          type="button" onClick={() => this.setState({ failed: false })}
          className="mt-3 rounded-lg border border-amber-400 px-3 py-1.5 text-[12px] font-medium transition-colors hover:bg-amber-100 dark:border-amber-700 dark:hover:bg-amber-900/40"
        >
          Try again
        </button>
      </div>
    );
  }
}
